import {addDays, format, startOfMonth, getDaysInMonth, getDay, parse, parseISO, eachDayOfInterval } from 'date-fns';
import firstBy from 'thenby';

// using events array, create a set of events by date, starting from today, aiming for a sum of 4 hours' worth of events using the estimatedTime property
export const distributeEvents = (events, startDate, daysOff=[], hoursPerDay=4, studySpeed=1) => {
  const hoursPerDayMinimum = .25;
  if (hoursPerDay < hoursPerDayMinimum) {
    hoursPerDay = hoursPerDayMinimum;
  }

  const eventsByDate = {};

  let currentDate = parse(startDate, 'yyyy-MM-dd', new Date());
  let currentDayEvents = [];
  let currentDayTime = 0;

  events.forEach(event => {
    // estimatedTime is in minutes
    const eventTime = ((event.estimatedTime || 0) * (event?.custom ? 1 : studySpeed)) / 60;
    if (currentDayTime + eventTime > hoursPerDay && currentDayTime > 0) {
      currentDate = addDays(currentDate, 1);

      while (daysOff.includes(format(currentDate, 'yyyy-MM-dd'))) {
        eventsByDate[format(currentDate, 'yyyy-MM-dd')] = [];
        currentDate = addDays(currentDate, 1);
      }
      currentDayEvents = [];
      currentDayTime = currentDayTime >= hoursPerDay ? 0 : (hoursPerDay - currentDayTime) * -1
    }
    event.complete = false;
    currentDayEvents.push(event);
    currentDayTime += eventTime;
    eventsByDate[format(currentDate, 'yyyy-MM-dd')] = [...currentDayEvents];
  });

  // make sure all days off are included in events by date so that we can account for them in the rebalance modal
  daysOff.forEach(dayOff => {
    if (!eventsByDate[dayOff]) {
      eventsByDate[dayOff] = [];
    }
  });

  return eventsByDate;
};

export const getWeeksToDisplay = (defaultDate, addPadding=true) => {
  // total days to render =
  // day index on start of month + total days in month
  // divided by 7
  const daysPriorToStartOfMonth = getDay(startOfMonth(defaultDate));
  const daysInMonth = getDaysInMonth(defaultDate);
  const totalDays = daysPriorToStartOfMonth + daysInMonth;
  return Math.ceil(totalDays / 7)
}

export const calculateDaysOff = (scheduledDays) => {

  try {
    const dateKeys = Object.keys(scheduledDays);

    if (dateKeys.length === 0) {
      return { earliestDay: null, latestDay: null, daysOff: 0 };
    }

    // Parse all date keys into Date objects
    const dates = dateKeys.map(date => parseISO(date));

    // Find the earliest and latest dates
    const earliestDay = dates.reduce((earliest, current) => (current < earliest ? current : earliest));
    const latestDay = dates.reduce((latest, current) => (current > latest ? current : latest));

    // Get all dates in the interval from earliest to latest
    const allDates = eachDayOfInterval({ start: earliestDay, end: latestDay });

    // Format all dates to the same string format as the object keys
    const allDateKeys = allDates.map(date => format(date, 'yyyy-MM-dd'));

    // Calculate the days off
    const daysOff = allDateKeys.filter(date => scheduledDays[date] && scheduledDays?.[date]?.length === 0);

    return daysOff.reduce((acc, curr) => ([...acc, curr]), []);

  } catch (error) {
    return [];
  }
}

export const formatEstimatedTime = (estimatedTime) => {

  const estHours = Math.floor(estimatedTime / 60);
  const estMin = Math.round(estimatedTime % 60);

  const formattedHours = estHours > 0 ? `${estHours}h ` : '';
  const formattedMin = estMin > 0 ? `${estMin}m` : '';

  return `${formattedHours}${formattedMin}`;
}